// スクロールアニメーション
const funcAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.9;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	check();
	if (document.readyState !== 'complete') {
		window.addEventListener('load', check, { once: true });
	}
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// ハートアニメーション: 刺激度が終わってからサイズ感を開始
const funcHearts = () => {
	const gaugesEls = document.querySelectorAll('.product__gauges');
	if (!gaugesEls.length) return;

	const animateGauges = (gaugesEl) => {
		const groups = gaugesEl.querySelectorAll('.product__hearts');
		let delay = 0;
		groups.forEach((group) => {
			const filled = group.querySelectorAll('.heart--filled');
			filled.forEach((heart, i) => {
				setTimeout(() => heart.classList.add('anim'), delay + i * 180);
			});
			// 前グループ終了(filled数×180ms) + アニメーション時間(800ms) + 余裕(200ms)
			delay += filled.length * 180 + 1000;
		});
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) return;
			animateGauges(entry.target);
			observer.unobserve(entry.target);
		});
	}, { threshold: 0.3 });

	gaugesEls.forEach((el) => observer.observe(el));
};

// 丸アイコン: 中央からスケールアップ
const funcCircles = () => {
	const circles = document.querySelectorAll('.product__circle');
	if (!circles.length) return;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) return;
			entry.target.classList.add('is-visible');
			observer.unobserve(entry.target);
		});
	}, { threshold: 0.5 });

	circles.forEach((el) => observer.observe(el));
};

window.addEventListener('DOMContentLoaded', () => {
	funcAnim();
	funcHearts();
	funcCircles();
});
